import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router';
import * as FullStorySDK from '@fullstory/browser';
import { useRollbar } from '@rollbar/react';
import { getProd } from '@figure/frontlib-onboarding-redux';
import { useIdentity, usePersonalLoan, useProfile } from 'shared/hooks';
import { PRODUCTS } from '@figure/frontlib-growth';

// https://developer.fullstory.com/introduction
// https://github.com/fullstorydev/fullstory-browser-sdk
const FullStory = () => {
  const location = useLocation();
  const rollbar = useRollbar();
  const { uuid: personalLoanUuid } = usePersonalLoan(false);
  const { isAuthenticated } = useIdentity();
  const { profile } = useProfile(false);

  // Initialize Fullstory
  useEffect(() => {
    FullStorySDK.init({ orgId: process.env.REACT_APP_FULLSTORY_ORG_ID, devMode: !getProd() });
    return () => {
      FullStorySDK.shutdown();
    };
  }, []);

  // Set FS links in rollbar
  useEffect(() => {
    rollbar.configure({
      transform: (payload) => {
        payload.custom = payload.custom || {};
        payload.custom.fullstoryUrl = FullStorySDK.getCurrentSessionURL(true);
      },
    });
  }, [rollbar]);

  // Turn on FS for whitelisted routes only
  useEffect(() => {
    const whitelistRoutes = ['/applications/start', '/applications/:uuid'];
    const match = matchPath(location.pathname, {
      path: whitelistRoutes,
    });

    if (match) FullStorySDK.restart();
    else FullStorySDK.shutdown();
  }, [location]);

  // Identify the user once authenticated, add initial user vars
  useEffect(() => {
    if (isAuthenticated && personalLoanUuid && profile.uuid) {
      const userVars = { productType: PRODUCTS.PERSONAL_LOAN, appUuid: personalLoanUuid };

      FullStorySDK.identify(profile.uuid, userVars);
    }
  }, [isAuthenticated, personalLoanUuid, profile.uuid]);

  return null;
};

export default FullStory;
